module.exports = __webpack_public_path__ + "img/user-black.2bc92a2e.svg";